/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Amiruzzaman",
  title: "Hi, I'm Amiruzzaman",
  subTitle: emoji(
    "A dedicated and aspiring Software Engineer with a solid foundation in web development. Passionate about learning and growth, I have experience designing responsive websites and tutoring in computer science. Eager to contribute my skills to cutting-edge projects, I aspire to pursue a Master's in Computer Science for further impact."
  ),
  resumeLink:
    "https://drive.google.com/file/d/17iIi-IXYbJPi3XWa6qeQna9mr1Wvs6N9/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/amiruzzaman1",
  linkedin: "https://www.linkedin.com/in/amiruzzaman1/",
  gmail: "amirzaman24@gmail.com",
  facebook: "https://www.facebook.com/amiruzzaman.anan/",
  instagram: "https://www.instagram.com/amiruzzaman_anan/",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "About Me",
  subTitle:
    "ENTHUSIASTIC SOFTWARE ENGINEER EAGER TO EMBRACE DIVERSE TECH STACKS AND UNLEASH THE POWER OF AI",
  skills: [
    emoji(
      "⚡ Committed to continuous learning in web development and machine learning."
    ),
    emoji(
      "⚡ Actively engage in diverse projects, applying AI and ML techniques."
    ),
    emoji(
      "⚡ Dedicated to personal and professional growth through tutoring and exploration of cutting-edge technologies."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "Css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Php",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Laravel",
      fontAwesomeClassname: "fab fa-laravel"
    },
    {
      skillName: "Wordpress",
      fontAwesomeClassname: "fab fa-wordpress"
    },
    {
      skillName: "Android",
      fontAwesomeClassname: "fab fa-android"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "BRAC University",
      logo: require("./assets/images/brLogo.jpg"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "January 2019 - January 2023"
      /* desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
      */
    },
    {
      schoolName: "Bangladesh International School & College, Jeddah",
      logo: require("./assets/images/sch-removebg-preview.png"),
      subHeader: "Higher Secondary Certificate",
      duration: "August 2016 - May 2018"
    },
    {
      schoolName: "Bangladesh International School & College, Jeddah",
      logo: require("./assets/images/sch-removebg-preview.png"),
      subHeader: "Secondary School Certificate",
      duration: "January 2013 - April 2016"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Programming", //Insert stack or technology you have experience in
      progressPercentage: "85%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Full Stack",
      progressPercentage: "70%"
    },
    {
      Stack: "Artificial Intelligence",
      progressPercentage: "65%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer (Project Based)",
      company: "Noor Wares and Motor Parts",
      companylogo: require("./assets/images/NLogo.png"),
      date: "February 2023 – Present",
      descBullets: [
        "Designed and created websites and web applications that meet client or project requirements.",
        "Ensured websites are responsive and compatible with various browsers and devices for optimal user experience.",
        "Integrated databases and server-side technologies to support dynamic content and functionality."
      ]
    },
    {
      role: "Tutor",
      company: "Caretutors",
      companylogo: require("./assets/images/327340132_879968119944888_7062559245861704624_n.png"),
      date: "December 2019 – Present",

      descBullets: [
        "Tailored teaching methods and materials to meet the diverse learning needs of individual students.",
        "Provided one-on-one tutoring sessions to address specific challenges and reinforce key concepts in Computer Science.",
        "Delivered in-depth instruction and mentorship to students, emphasizing the enhancement of their proficiency in Mathematics, Physics, Chemistry, and Biology."
      ]
    },
    {
      role: "Student Tutor (Undergraduate Teaching Assistant)",
      company: "BRAC University",
      companylogo: require("./assets/images/brLogo.jpg"),
      date: "June 2022 – Dec 2022",
      descBullets: [
        "Provided comprehensive guidance and support to students in enhancing their proficiency in Python and Java programming languages.",
        "Evaluated students’ progress and provided constructive feedback to promote continuous improvement and growth.",
        "Collaborated with faculty members to design and develop educational materials and resources for programming courses"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Live Projects",
  subtitle:
    "Helped startups and companies with innovative tech solutions and showcasing personal projects.",
  projects: [
    {
      image: require("./assets/images/byere.jpg"),
      projectName: "Bulk Account",
      projectDesc:
        "Crafted an elegant e-commerce platform using the versatility of WordPress.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://gvaccountbuy.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/abnae.jpg"),
      projectName: "Additional Portfolio Site",
      projectDesc:
        "Utilized Next JS, Tailwind CSS & Framer Motion for a Dynamic Showcase of Expertise.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://portamir.vercel.app/"
        }
      ]
    },
    {
      image: require("./assets/images/bas.jpg"),
      projectName: "Maszid Noor",
      projectDesc:
        "Developed a sophisticated mosque website using the WordPress platform.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://maszidnoor.com/"
        }
      ]
    },
    {
      image: require("./assets/images/cyber.jpg"),
      projectName: "Cyber Bullying Detection",
      projectDesc:
        "Explored the development of a sophisticated multilingual cyberbullying bullying system.",
      footerLink: [
        {
          name: "View Project",
          url: "https://amiruzzaman.vercel.app/project/Cyber_Bullying_Detection"
        }
      ]
    },
    {
      image: require("./assets/images/nwekdflk.png"),
      projectName: "Question Answer Model",
      projectDesc:
        "Developed QA model using advanced neural networks: BERT, DistilBERT, and more.",
      footerLink: [
        {
          name: "View Project",
          url: "https://amiruzzaman.vercel.app/project/Question_Answering_Model_(Bert)"
        }
      ]
    },
    {
      image: require("./assets/images/nswe.jpg"),
      projectName: "Chatbots",
      projectDesc:
        "Crafted two NLP chatbots employing neural networks, each trained on unique datasets.",
      footerLink: [
        {
          name: "View Project",
          url: "https://amiruzzaman.vercel.app/project/NLP_ChatBot"
        }
      ]
    },
      {
      image: require("./assets/images/aurexaa.jpg"),
      projectName: "Aurexaa",
      projectDesc:
        "Developed a comprehensive e-commerce website using the WordPress platform.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://aurexaa.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Showcasing my Achievements, Certifications, Award Letters, and other notable accomplishments that highlight my expertise",

  achievementsCards: [
    {
      title:
        "Appearance on VC's List and on Dean's List (VC's List - 3 times and Dean's List - 3 times)",
      subtitle:
        "Featured on VC's List thrice and consistently recognized on the Dean's List three times for academic excellence and achievements.",
      image: require("./assets/images/brLogo.jpg"),
      imageAlt: "",
      footerLink: []
    },
    {
      title: "Campus Ambassador at Caretutors.com",
      subtitle:
        "Served as Campus Ambassador at BRAC University, representing caretutors.com, a premier tutor provider, fostering academic excellence and connections.",
      image: require("./assets/images/327340132_879968119944888_7062559245861704624_n.png"),
      imageAlt: "",
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/1dU3b75q1uUTOTZq0OT9opxlppoESHzs5/view?usp=sharing"
        }
      ]
    },
    {
      title: "Yoga and Meditation Activity",
      subtitle:
        "Engaged in Yoga and Meditation at Brac University's Savar residential campus, fostering mindfulness and well-being through peaceful practices.",
      image: require("./assets/images/brLogo.jpg"),
      imageAlt: "",
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/1Y_VmFfMZWR288iJthk7IU8_VKPnkCx1K/view?usp=sharing"
        }
      ]
    },
    {
      title: "High Distinction Award",
      subtitle:
        "Earned the prestigious High Distinction Award for exceptional academic achievement at Brac University, showcasing dedication and excellence in education.",
      image: require("./assets/images/brLogo.jpg"),
      imageAlt: "PWA Logo",
      footerLink: []
    },
    {
      title: "Merit Based Scholarship (Up to 50%)",
      subtitle:
        "Earn up to a 50% merit-based scholarship at Brac University. Recognizing excellence for academic achievements and dedication to learning.",
      image: require("./assets/images/brLogo.jpg"),
      imageAlt: "PWA Logo",
      footerLink: []
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Whether you're eager to discuss a project or just want to say hi, my inbox welcomes all. Connect anytime!",
  number: "+8801868984412",
  email_address: "amirzaman24@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
